module.exports = __webpack_public_path__ + "static/media/home.cb11c0c3.svg";